import { Account } from '@quick/client';
import React, { useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { useJoinedAccountsQuery } from '../../hooks/vendorlink/Account';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import AccountInfoOverview from './components/AccountInfoOverview';
import AvatarStatus from '../../components/shared-components/AvatarStatus';
import { Link } from 'react-router-dom';
import { useCurrentAccountId } from '../../redux/selector';
import OnboardingModal from './account-onboarding/OnboardingModal';
import { accountPrefixPath } from '../../hooks/vendorlink/Routing';

const MENU_ITEM_HEIGHT = 64;

const AccountSwitcher: React.FC = () => {
  const joinedAccounts = useJoinedAccountsQuery().data ?? [];
  joinedAccounts.sort(compareAccountName);
  const currentAccountId = useCurrentAccountId();
  const currentAccount = joinedAccounts.find((it) => it.accountId === currentAccountId);
  const [onboardingModalVisible, setOnboardingModalVisible] = useState(false);
  if (joinedAccounts.length === 0 || !currentAccount) {
    return <></>;
  }
  const menuItems = [
    ...joinedAccounts.map((account) => {
      return (
        <Menu.Item
          key={menuKey(account)}
          className="d-flex flex-column align-items-start justify-content-center"
          style={{ height: MENU_ITEM_HEIGHT }}
        >
          <Link to={`${accountPrefixPath(account.accountId)}`}>
            <AccountInfoOverview account={account} />
          </Link>
        </Menu.Item>
      );
    }),
    <Menu.Item
      key={-1}
      className="d-flex flex-column align-items-start justify-content-center px-4"
      style={{ height: MENU_ITEM_HEIGHT }}
      onClick={() => {
        setOnboardingModalVisible(true);
      }}
    >
      <div className="d-flex align-items-center">
        <AvatarStatus
          icon={<PlusOutlined className="font-size-label-l" />}
          type="primary"
          name={<span className="label-s">Add accounts</span>}
        />
      </div>
    </Menu.Item>,
  ];
  const profileMenu = (
    <Menu selectable={false} selectedKeys={[menuKey(currentAccount)]} className="nav-dropdown">
      {menuItems}
    </Menu>
  );
  return (
    <>
      <Dropdown placement="bottomRight" overlay={profileMenu}>
        <Button
          className="pl-1 pr-2 w-100 d-flex flex-shrink-1 align-items-center"
          type="text"
          size="large"
          style={{ minWidth: 0 }}
        >
          {currentAccount && <AccountInfoOverview account={currentAccount} hideAddress={true} />}
          <DownOutlined className="ml-2" />
        </Button>
      </Dropdown>
      {/* Modal should be outside of the dropdown. Otherwise it prevents the menu from closing properly. */}
      <OnboardingModal visible={onboardingModalVisible} onClose={() => setOnboardingModalVisible(false)} />
    </>
  );
};

const menuKey = (accountId: Account | undefined) => {
  return `c-${accountId?.accountId}`;
};

const compareAccountName = (a: Account, b: Account) => {
  return a.name.localeCompare(b.name);
};

export default AccountSwitcher;
